function RichardsonSelectNewStyle() {

}

RichardsonSelectNewStyle.funcs = {
    isInit: true,

    init: function() {
        var that = this;
        if (that.isInit) {
            $("#select-new-style-modal").on("submit", "#load-design-number", that.loadDesignNumber);
            $("#select-new-style-modal").on("submit", "#load-saved-design", that.loadSavedDesign);
            $("#select-new-style-modal").on("keypress", ".saved-design-number", _.debounce(that.onSearchSavedDesign, 500));
            $("#select-new-style-modal").on("keypress", ".design-number", _.debounce(that.onSearchProductModel, 500));
            
            that.isInit = false;
        }

        $("#select-new-style-modal form#load-saved-design").trigger("reset");
        $("#select-new-style-modal form#load-design-number").trigger("reset");
        that.load();
    },

    load: function() {
        UIkit.modal("#select-new-style-modal").show();
    },

    loadDesignNumber: function(event) {
        event.preventDefault();
        var design_number = $("#load-design-number input.design-number").val();
        console.log(design_number);
    },

    loadSavedDesign: function(event) {
        event.preventDefault();
        var design_number = $("#load-saved-design input.saved-design-number").val();
        console.log(design_number);
    },

    onSearchSavedDesign: function() {
        var keyword = $("#load-saved-design input.saved-design-number").val();
        RichardsonSelectNewStyle.funcs.searchSavedDesign(keyword);
    },

    searchSavedDesign: function(query) {
        var url = ub.config.host + '/richardson/search-saved-design/' + query;
        $("#select-new-style-modal .search-result-dropdown ul").html("");
        $("#select-new-style-modal .search-result-dropdown ul").html("<li>Searching...</li>");
        $("#load-saved-design input.saved-design-number").addClass("uk-disabled");
        UIkit.dropdown(".search-result-dropdown").show()
        $.ajax({
            url: url,
            type: "GET",
            dataType: "json",
            crossDomain: true,
            success: function (response) {
                $("#load-saved-design input.saved-design-number").removeClass("uk-disabled");
                $("#select-new-style-modal .search-result-dropdown ul").html("");
                $("#select-new-style-modal .search-result-dropdown ul").html(response.html);
                UIkit.dropdown(".search-result-dropdown").show();
            },

            error: function(error) {
                $.smkAlert({
                    text: 'Something went wrong while processing your request.',
                    type: 'warning'
                });
            }
        });
    },

    onSearchProductModel: function() {
        var keyword = $("#load-design-number input.design-number").val();
        RichardsonSelectNewStyle.funcs.searchProductModel(keyword);
    },

    searchProductModel: function(query) {
        var url = ub.config.host + '/richardson/search-product-model/' + query;

        $("#select-new-style-modal .search-result-dropdown-model ul").html("");
        $("#select-new-style-modal .search-result-dropdown-model ul").html("<li>Searching...</li>");
        $("#load-design-number input.design-number").addClass("uk-disabled");
        
        $.ajax({
            url: url,
            type: "GET",
            dataType: "json",
            success: function (response) {
                $("#load-design-number input.design-number").removeClass("uk-disabled");
                $("#select-new-style-modal .search-result-dropdown-model ul").html("");
                $("#select-new-style-modal .search-result-dropdown-model ul").html(response.html);
                UIkit.dropdown(".search-result-dropdown-model").show();
            },

            error: function(error) {
                $.smkAlert({
                    text: 'Something went wrong while processing your request.',
                    type: 'warning'
                });
            }
        });
    }
}